module.exports = __webpack_public_path__ + "static/img/pc-content-bg.34acf51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc-content-bg.png
// module id = ca5q
// module chunks = 0